import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {Component, Input, Inject, Output, EventEmitter, OnInit, AfterContentChecked, AfterViewInit} from '@angular/core';
import {MatChip, MatChipInputEvent} from '@angular/material/chips';
import {ThemePalette} from '@angular/material';
export interface Language {
  name: string;
}

/**
 * @title Chips with input
 */
@Component({
  selector: 'material-chips-input',
  template: `<mat-form-field class="supported-lang-chip-list">
    <mat-chip-list #chipList aria-label="Language selection">
      <mat-chip *ngFor="let lang of languages" [selectable]="selectable" [id]="setId(lang.name)" (click)="switchLanguage(lang)"
                [removable]="removable" (removed)="remove(lang)">
        {{lang.name}}
        <mat-icon  [id]="setId(lang.name)" matChipRemove *ngIf="removable">cancel</mat-icon>
      </mat-chip>
      <input
             [matChipInputFor]="chipList"
             [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
             [matChipInputAddOnBlur]="addOnBlur"
             (matChipInputTokenEnd)="add($event)">
    </mat-chip-list>
  </mat-form-field>`,
  styles: [`
    .supported-lang-chip-list {
      width: 100%;
    }

      #selectedChip{ background-color: #00b0ff;color:white;}
    `]
})
export class MaterialChipsInputComponent implements OnInit,AfterViewInit {
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  languages: Language[] = [];
  private selectedLang = '';
  @Output() reload:EventEmitter<string> =  new EventEmitter();
  @Output() ready:EventEmitter<MaterialChipsInputComponent> =  new EventEmitter<MaterialChipsInputComponent>();
  @Output() langAdded:EventEmitter<string> =  new EventEmitter();

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our supported language
    if ((value || '').trim()) {
      this.languages.push({name: value.trim()});
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.langAdded.emit( value.trim());
  }

  remove(lang: Language): void {
    const index = this.languages.indexOf(lang);

    if (index >= 0) {
      this.languages.splice(index, 1);
    }
  }

  switchLanguage(lang:Language) {
    this.selectedLang = lang.name;
    this.reload.emit(lang.name);
  }


  setLanguageArray(arrLang:string[]) {
    this.languages.length = 0;
    if(arrLang == null) {
      return;
    }
    for(let i = 0;i<arrLang.length;i++) {
      this.languages.push({name:arrLang[i]});
    }

  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    console.log('Material Chips instantiated');
  }

  // this method is used for css style application. Elements with id=selectedChip is applied with a css.
  setId(lang: string):string {
    if(this.selectedLang === lang) {
      return 'selectedChip' ;
    }
    return '';
  }

  setSelectedLanguage(selectedLang:string) {
    this.selectedLang = selectedLang;
  }

  resetLanguageArray() {
    this.languages.length = 0;
  }

}
